import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'torqcloud-ui'

import { playground } from '@/constants/routing'
import useOrganizationUsageAccess from '@/hooks/useOrganizationUsageAccess'

export default function OrganizationUsageGuard({ children }: { children: ReactNode }) {
  const { hasMetadata } = useAuth()
  const { canViewOrganizationUsage } = useOrganizationUsageAccess()

  if (!hasMetadata) {
    return null
  }

  if (!canViewOrganizationUsage) {
    return <Navigate to={playground()} replace />
  }

  return <>{children}</>
}
